<template>
  <div class="small-filter-row">
    <div class="filter-container">
      <BButton class="filter-button" @click="$emit('add-filter')" :disabled="disabled">
        <div class="filter-icon">
          <Plus :size="15" :stroke-width="1.5" />
        </div>
        <span class="filter-text">Filter</span>
      </BButton>

      <div class="filter-tabs">
        <Button  v-for="option in options"
                  :key="option.value"
                  :disabled="disabled"
                  class="filter-tab"
                  :class="{
                    'active': modelValue === option.value,
                    'skewed': false && isSkewedTheme
                  }"
                  @click="handleSelect(option.value)">
          <span class="tab-content" :class="{ 'skewed': isSkewedTheme }">
            {{ option.label }}
          </span>
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Plus } from 'lucide-vue-next';

export default {
  name: 'SmallFilterRow',

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: String,
      default: null
    },
    options: {
      type: Array,
      default: () => [
        { value: 'all', label: 'All Details' },
        { value: 'medium', label: 'Medium' },
        { value: 'minimal', label: 'Minimal' }
      ]
    }
  },

  components: {
    Plus
  },

  emits: ['update:modelValue', 'add-filter'],

  computed: {
    ...mapGetters('app', ['isSkewedTheme'])
  },

  methods: {
    handleSelect(value) {
      this.$emit('update:modelValue', value);
    }
  }
};
</script>

<style lang="scss" scoped>
.small-filter-row {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
}

.filter-container {
  display: flex;
  align-items: center;
  gap: 24px;
}

.filter-button {
  display: flex;
  align-items: center;
  color: var(--color-foreground);
  gap: 7px;
  padding: 8px 10px;
  // background: transparent;
  border: none;
  border-radius: var(--radius-xs);
  cursor: pointer;
  transition: background-color 0.15s;

  &:hover {
    background: rgba(255, 255, 255, 0.05);
  }
}

.filter-icon {
  display: flex;
  align-items: center;
  justify-center: center;
  width: 15px;
  height: 15px;

  svg {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.filter-text {
  font-family: 'BMWTypeNext Pro', sans-serif;
  font-size: 11.3px;
  line-height: 15px;
  white-space: nowrap;
}

.filter-tabs {
  display: flex;
  align-items: center;
  column-gap: 10px;
  padding: 0 11px 0 0;
}
.btn:disabled, .btn.disabled{
  background-color: none !important;
}
.filter-tab {
  background: var(--bs-secondary-bg) !important;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 8px 12px;
  cursor: pointer;
  transition: all 0.15s;
  margin-right: -11px;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  &.active {
    // background: rgba(255, 255, 255, 0.2);
    border-bottom-color: var(--target-primary);
  }

  &.skewed {
    transform: skewX(var(--target-skew-angle-inverse));
  }
}

.tab-content {
  display: flex;
  align-items: center;
  gap: 2px;
  font-family: 'BMWTypeNext Pro', sans-serif;
  font-size: 14px;
  line-height: 18px;
  color: var(--color-muted-foreground);
  white-space: nowrap;
  border: none;

  .filter-tab.active & {
    color: var(--color-foreground);
  }

  &.skewed {
    transform: skewX(var(--target-skew-angle)) scaleY(1.1247);
  }
}
</style>
